<mat-sidenav-container class="sidenav-container">
<mat-sidenav #drawer class="sidenav" [class.sidenav-collapsed]="soloIconos" fixedInViewport="true" [fixedTopGap]="0"
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="!(isHandset$ | async) && viewSidenav" >
   
  <!-- CABECERA DEL MENÚ -->
<div class="sidenav-logo-area">
      <a [routerLink]="'/'">
      <img *ngIf="!soloIconos" src="assets/images/blanco.png" alt="Logo Seguros Caroni" class="logo-img">
      <img *ngIf="soloIconos" src="assets/images/caroblanco.png" alt="Logo Mini" class="logo-img">
      </a>
    </div>

    <div class="linea"></div>

    <div class="toggle-container">
      <button *ngIf="viewSidenav" mat-icon-button (click)="onMenuClick()">
      <!-- <button *ngIf="viewSidenav" mat-icon-button (click)="drawer.toggle()"> -->
        <mat-icon>menu</mat-icon>
      </button>
    </div>

    <!-- BIENVENIDA -->
    <div class="sidenav-menu-area" >
      <ng-container *ngIf="!soloIconos">
        <div class="welcome-area" *ngFor="let usuario of datos">
          <div class="welcome-info-row">
            <img class="avatar-img" src="assets/images/user.png" alt="Avatar" />
            <div class="welcome-info-text">
              <div class="welcome-title">¡Bienvenido!</div>
              <div class="welcome-user">{{ usuario.NOMBRE }}</div>
              <div class="welcome-user">Fecha: {{ today }}</div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>



    <!-- OPCIONES DEL MENÚ -->
    <mat-nav-list>

      <mat-nav-list>
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
              <mat-icon>verified_user</mat-icon>
              <span *ngIf="!soloIconos">Pólizas</span>
            </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list *ngIf="!soloIconos">
            <a mat-list-item [routerLink]="'/insurance-policy'">
              <mat-icon>description</mat-icon>
              <span>Consulta de pólizas</span>
            </a>
          </mat-nav-list>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>request_quote</mat-icon>
              <span *ngIf="!soloIconos">Cotizar/Emitir </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list *ngIf="!soloIconos"></mat-nav-list>
             <a mat-list-item [routerLink]="'/funeral-quote'" class="letras">
              <mat-icon>how_to_reg</mat-icon>
              <span>Pólizas de funerario</span>
            </a>
            <a mat-list-item [routerLink]="'/hcm-quote'" class="letras">
              <mat-icon>how_to_reg</mat-icon>
              <span>Pólizas de HCM</span>
            </a>
            <a mat-list-item [routerLink]="'/car-quote'" class="letras">
              <mat-icon>how_to_reg</mat-icon>
              <span>Pólizas de automóvil</span>
            </a>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
              <mat-icon>credit_card</mat-icon>
              <span *ngIf="!soloIconos">Pagos</span>
            </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list *ngIf="!soloIconos">

              <a mat-list-item [routerLink]="'/payment'">
              <mat-icon>payment</mat-icon>
              <span>Pago en línea</span>
            </a>

              <a mat-list-item [routerLink]="'/pending-paid'"> 
              <mat-icon>print</mat-icon>
              <span>Impresión relación de ingreso</span>
            </a>

              <a mat-list-item class="letras" mat-list-item (click)="getCuenta()">
                <mat-icon class="material-icons">how_to_reg</mat-icon>
                <span>Impresión relación de ingreso</span>
              </a>
            </mat-nav-list>
            <!--<a  class="letras" mat-list-item [routerLink]="'/deposits-and-transfer'"><mat-icon class="material-icons">how_to_reg</mat-icon>Depósitos y transferencias</a>-->
          </mat-expansion-panel>
          <!--<mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="principal-options">
                Siniestros
              </mat-panel-title>
            </mat-expansion-panel-header>
            <a  class="letras" mat-list-item [routerLink]="'/claims-consultation'"><mat-icon class="material-icons">how_to_reg</mat-icon>Consulta de siniestros</a>
          </mat-expansion-panel>-->
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
              <mat-icon>medical_services</mat-icon>
              <span *ngIf="!soloIconos">Proveedores</span>
            </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list *ngIf="!soloIconos">
            <a mat-list-item [routerLink]="'/healthcare-providers'">
              <mat-icon>monitor_heart</mat-icon>
              <span>Proveedores de salud</span>
            </a>
            <a mat-list-item [routerLink]="'/aps-providers'"
              ><mat-icon class="material-icons">how_to_reg</mat-icon><span>Proveedores de APS</span></a >
            <a mat-list-item (click)="getProveedor()" >
              <mat-icon class="material-icons">how_to_reg</mat-icon><span>Proveedores odontológicos</span></a>
            <a mat-list-item (click)="getOftalmologo()" >
                <mat-icon class="material-icons">how_to_reg</mat-icon><span>Proveedores Oftalmológicos</span></a> 
            <a mat-list-item (click)="getDermatologo()" >
            <mat-icon class="material-icons">how_to_reg</mat-icon><span>Proveedores Dermatológicos</span></a >  
            <a mat-list-item (click)="getAuxiliar()" >
            <mat-icon class="material-icons">how_to_reg</mat-icon><span>Auxiliar psicológico</span></a >  
            <a mat-list-item (click)="getFunerario()" >
            <mat-icon class="material-icons">how_to_reg</mat-icon><span>Servicio funerarios</span></a >  
            </mat-nav-list>  
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
              <mat-icon>group</mat-icon>
              <span *ngIf="!soloIconos">Gestión Usuarios</span>
            </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list *ngIf="!soloIconos">

            <a mat-list-item [routerLink]="'/key-change'">
              <mat-icon>how_to_reg</mat-icon>
              <span>Cambiar clave</span>
            </a>
            </mat-nav-list>
          </mat-expansion-panel>
          </mat-accordion>
          <a mat-list-item [routerLink]="'/download-area'">
        <mat-icon>cloud_download</mat-icon>
        <span *ngIf="!soloIconos">Zona de Descarga</span>
      </a>
      <a mat-list-item class="solo letras principal-options" *ngIf="url != '/login' && true" (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span *ngIf="!soloIconos">Salir</span>
      </a>
      </mat-nav-list>
      <div class="sidebar-bottom"></div>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content [ngStyle]="{'margin-left': (isHandset$ | async) ? '0' : (soloIconos ? '85px' : '350px')}">
    
    <!-- <mat-toolbar class="toolbar-inside-content" *ngIf="url !== '/'"> -->
    <mat-toolbar class="toolbar-inside-content" *ngIf="(isHandset$ | async) || (url !== '/')">
      <button mat-icon-button (click)="drawer.toggle()" *ngIf="isHandset$ | async">
      <mat-icon>menu</mat-icon>
    </button>
      <!-- <div class="linea-toolbar"></div>  -->
      <ng-container *ngIf="soloIconos || (isHandset$ | async)">
        <div class="toolbar-welcome" *ngFor="let usuario of datos">
          <img class="avatar-img" src="assets/images/user.png" alt="Avatar" />
          <span class="welcome-user">{{ usuario.NOMBRE }}</span>
        </div>
      </ng-container>
    </mat-toolbar>
    <div class="main-content" content >
      <ng-content></ng-content>
    </div>
    <!-- <app-footer></app-footer> -->
  </mat-sidenav-content>
</mat-sidenav-container>
